exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-fluid, .row {\n  height: 100%\n}\n\n.avatar, .content {\n  margin-top: 40px;\n}\n\nh2 {\n  font-family: 'Roboto', sans-serif;\n  font-size: 40px;\n  font-weight: 300;\n  margin-top: 20px;\n  margin-bottom: 50px;\n}\n\nh3 {\n  font-family: 'Roboto', sans-serif;\n  font-size: 24px;\n  font-weight: 100;\n  margin-top: 20px;\n  margin-bottom: 50px;\n}\n\n.outline {\n  border-radius: 2px;\n  box-shadow: 2px 4px 2px 0px rgba(0, 0, 0, .5), 0 6px 6px 0 rgba(0, 0, 0, .5)\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Jose.Soto/Documents/Websites/SecretSanta/src/app/assigned-user/assigned-user.component.css
// module id = ../../../../../src/app/assigned-user/assigned-user.component.css
// module chunks = main